import jwtDecode from 'jwt-decode';
import { verify, sign } from 'jsonwebtoken';
//
import { BASIC_AUTH } from 'config';

import axios from './axios';

// ----------------------------------------------------------------------

const jwtDecoded = (accessToken) => jwtDecode(accessToken);

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decoded.exp > currentTime;
};

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//     // You can do what ever you want here, like show a notification
//   }, timeLeft);
// };

// ----------------------------------------------------------------------

const setSession = (data) => {
  if (data) {
    sessionStorage.setItem('storage', JSON.stringify(data));

  } else {
    sessionStorage.removeItem('storage');
    sessionStorage.removeItem('lastInteractionTime');
    // sessionStorage.removeItem('connecteTime');

    axios.defaults.headers.common.Authorization = `Basic ${BASIC_AUTH}`;

    // delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession, verify, sign, jwtDecoded };
